// extracted by mini-css-extract-plugin
export var section = "styles-module--section--XfPNb";
export var PinHover = "styles-module--PinHover--omaxj";
export var mapContainer = "styles-module--mapContainer--4CfDL";
export var backAndForthRight = "styles-module--backAndForthRight--cbcMQ";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--yUed5";
export var animateBg = "styles-module--animateBg--JQkwz";